const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/main/timeline/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
import { saveLastVisitedMainVisualization, saveLastVisitedView } from '@/features/visualizations/utils/lastVisitedVisualizationView';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/main/timeline/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: ({
    params
  }) => {
    const loopId = Number(params.loopId);
    saveLastVisitedView(loopId, {
      type: 'main'
    });
    saveLastVisitedMainVisualization(loopId, 'timeline');
  },
  staticData: {
    topNav: {
      title: i18n.t($ => $.roadmaps.title)
    }
  }
});